// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__RBtNK","printsize":"Button_printsize__Daufk","primary":"Button_primary__XYgy-","transparent":"Button_transparent__33FBX"};